import {
  minLength,
  maxLength,
  helpers,
  email,
  alphaNum
} from "vuelidate/lib/validators";
const namePattern = helpers.regex(
  "alpha",
  /^[A-Za-zàáâãäåÀÁÂÃÄÅæÆçÇèéêëÈÉÊËìíîïÌÍÎÏñÑòóôõöÒÓÔÕÖœŒùúûüÙÚÛÜýÿÝŸ ']*$/
);
const phonePattern = helpers.regex("phoneNumber", /^[+]?[0-9]{6,12}$/);
const fiscalCodePattern = helpers.regex(
  "fiscalCode",
  /^[0-9]{11}|[a-zA-Z]{6}[0-9]{2}[a-zA-Z][0-9]{2}[a-zA-Z][0-9]{3}[a-zA-Z]$/
);

const cartaIdentitaElettronicaPattern = helpers.regex(
  "CL",
  /^[a-zA-Z]{2}[0-9]{5}[a-zA-Z]{2}$/
);

const cartaIdentitaPattern = helpers.regex("CI", /^[a-zA-Z]{2}[0-9]{7}$/);

const documentNumberPattern = helpers.regex(
  "documentNumber",
  /^[a-zA-Z-0-9]+$/
);

const addressPattern = helpers.regex("address", /^[0-9A-Za-zàèéìòù ']*$/);
const cityPattern = helpers.regex("city", /^[-A-Za-zàèéìòù ']*$/);
const houseNumberPattern = helpers.regex(
  "houseNumberPattern",
  /^[-0-9A-Za-z/ .']*$/
);

const fullAddressPattern = helpers.regex(
  "fullAddressPattern",
  /^[-0-9A-Za-zàèéìòù,./ ']*$/
);

const patterns = {
  FIRST_NAME: {
    minLength: minLength(2),
    maxLength: maxLength(30),
    namePattern
  },
  LAST_NAME: {
    minLength: minLength(2),
    maxLength: maxLength(30),
    namePattern
  },
  EMAIL: {
    email: email
  },
  PHONE_NUMBER: {
    phonePattern
  },
  FISCAL_CODE: {
    fiscalCodePattern
  },
  MGM_CODE: {
    alphaNum
  },
  CI: {
    cartaIdentitaPattern
  },
  CL: {
    cartaIdentitaElettronicaPattern
  },
  DOCUMENT_NUMBER: {
    documentNumberPattern
  },
  ADDRESS: {
    addressPattern
  },
  CITY: {
    cityPattern
  },

  HOUSE_NUMBER: {
    houseNumberPattern
  },
  FULL_ADDRESS: {
    fullAddressPattern
  }
};

export default patterns;
